import { useEffect, useRef } from 'react';
import { OfferCard as OfferPresentationCard } from '@mts/ui';
import { buildOfferDisplayModel } from '@mts/shared/offerDisplay';
import { getOfferHref } from '../../utils/deals';

export default function OfferCard({ offer, variant = 'standard', placementId = null, onImpression }) {
  const cardRef = useRef(null);
  const recordedRef = useRef(false);
  const href = getOfferHref(offer);
  const display = buildOfferDisplayModel(offer, { tenant: offer?.tenant || { name: offer?.tenantName } });
  useEffect(() => {
    if (!cardRef.current || typeof onImpression !== 'function' || recordedRef.current) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5) || recordedRef.current) return;
      recordedRef.current = true;
      onImpression({ offer, placementId, variant });
      observer.disconnect();
    }, { threshold: 0.5 });
    observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [offer, onImpression, placementId, variant]);
  return <div ref={cardRef} className="h-full"><OfferPresentationCard display={display} href={href} action={<span className="mt-3 block text-sm font-semibold text-primary">{display.availabilityLabel} · View Offer</span>} /></div>;
}
